/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';

import './ConsoleLog.scss';

const ConsoleLog: FunctionComponent = (): JSX.Element => {
    const consoleLogHeaderText = 'Console Log';
    return (
        <div className="console-log-container">
            <div className="console-log-heading">{consoleLogHeaderText}</div>
            <div className="console-log section-title disabled">No information available!</div>
        </div>
    );
};

export default ConsoleLog;
